/* eslint-disable react-hooks/exhaustive-deps */
import { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import { Input, Loader, ModalGeneric, Switch, TextArea } from 'ypf-pas-general-ui-components';

import { capitalize, formatDateToSpanish, validateDecimalInput } from '../../../utils/formatUtils';
import '../WorkReportModals.scss';
import './RejectModal.scss';
import ProgramPointList from '../ProgramPointModal/ProgramPointList/ProgramPointList';
import { ubicationTypeEnum } from '../../../utils/dataStatus';
import { aprobador } from '../../../security/constantsRols';
import { checkRol } from '../../../security';
import useLocationProgramPoints, {
  defaultInitialValues
} from '../ProgramPointModal/useLocationProgramPoints';

const RejectModal = (props) => {
  const {
    unidadMedida,
    asignationType,
    show,
    onHide,
    onAccept,
    dailyWorkReportId,
    positionName,
    lineName,
    um,
    quantity,
    date,
    tienePuntosPrograma,
    estadoEnum,
    tipoUbicacionEnum,
    eventoSigla,
    line
  } = props;

  const { day, month, year } = formatDateToSpanish(date);
  const [disablePrimaryAction, setDisablePrimaryAction] = useState(false);
  const [showAlert, setShowAlert] = useState(false);
  const isApprover = checkRol(aprobador);

  const isPozoOrLocation =
    tipoUbicacionEnum === ubicationTypeEnum.pozo ||
    tipoUbicacionEnum === ubicationTypeEnum.locacion;

  const defaultValues = {
    ...defaultInitialValues,
    quantity,
    requireAccordance: true,
    requestAttachFile: false,
    comment: ''
  };

  const {
    getProgramPointsData,
    rejectWithProgramPoints,
    rejectQuantity,
    calculateTotalValue,
    values,
    setFieldValue,
    resetForm,
    setFieldTouched,
    loading
  } = useLocationProgramPoints({
    line,
    initialValues: defaultValues,
    validationSchema: undefined
  });

  useEffect(() => {
    const hasCompleteData = values.locations.every((location) =>
      location.programPoints.every(
        (PP) =>
          Object.prototype.hasOwnProperty.call(PP, 'code') &&
          Object.prototype.hasOwnProperty.call(PP, 'subCode') &&
          Object.prototype.hasOwnProperty.call(PP, 'cost')
        // Object.prototype.hasOwnProperty.call(PP, 'clasification')))
      )
    );

    setDisablePrimaryAction(!isPozoOrLocation && !values.quantity);
    if (hasCompleteData) {
      setShowAlert(
        values.locations.some((location) =>
          location.programPoints.some(
            (programPoint) =>
              programPoint?.code === null ||
              programPoint?.code === '' ||
              programPoint?.subCode === null ||
              programPoint?.subCode === '' ||
              programPoint?.cost === null ||
              programPoint?.cost === '' ||
              programPoint?.cost?.nombre === '' ||
              programPoint?.code?.nombre === '' ||
              programPoint?.subCode?.nombre === ''
          )
        )
      );
    } else {
      setShowAlert(true);
    }
  }, [values.locations]);

  useEffect(async () => {
    if (show) {
      setFieldValue('quantity', quantity);
      if (isPozoOrLocation) {
        await getProgramPointsData();
      }
    } else resetForm();
  }, [show]);

  const onExit = () => {
    setShowAlert(false);
    onHide();
  };

  const handlePrimary = async () => {
    if (isPozoOrLocation) {
      await rejectWithProgramPoints({
        cantidad: values?.locationTotalValue,
        comentario: values?.comment,
        requiereConformidad: values?.requireAccordance,
        requiereAdjuntar: values?.requestAttachFile,
        locations: values?.locations
      });
    } else {
      await rejectQuantity({
        cantidad: values?.quantity,
        comentario: values?.comment,
        requiereConformidad: values?.requireAccordance,
        requiereAdjuntar: values?.requestAttachFile
      });
    }
    onAccept({
      newQuantity: isPozoOrLocation ? +values.locationTotalValue : +values.quantity,
      requireAccordance: values?.requireAccordance
    });
    onExit();
  };

  const hasTotalValuesChange = JSON.stringify(
    values.locations.map((location) => location.totalValue)
  );

  useEffect(() => {
    const { locationTotalValue, locationTotalValueFijado } = calculateTotalValue(values.locations);

    setFieldValue(`locationTotalValue`, locationTotalValue);
    setFieldValue(`locationTotalValueFijado`, locationTotalValueFijado);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [hasTotalValuesChange]);

  const invalidQuantity =
    isPozoOrLocation &&
    (values?.locations || [])
      .filter((loc) => loc?.habilitaVentana)
      .flatMap((location) => location?.programPoints || [])
      .find((qntyObj) => !qntyObj?.quantity);

  return (
    <ModalGeneric
      backdrop="static"
      infoModal
      onHide={onExit}
      primaryAction={handlePrimary}
      primaryActionDisabled={
        loading ||
        !values?.comment?.trim() ||
        invalidQuantity ||
        (isApprover && disablePrimaryAction)
      }
      primaryActionLabel="Comunicar"
      secondaryAction={onExit}
      secondaryActionLabel="Salir"
      show={show}
      size="xl"
      title={isPozoOrLocation ? 'Datos operativos' : 'Rechazar - Editar'}
    >
      <>
        {loading && <Loader show={loading} text="CARGANDO ..." />}
        {!isPozoOrLocation && (
          <>
            <div className="text-center modal-info mb-4">
              <div className="d-flex justify-content-center flex-wrap">
                <span>&quot;{positionName}</span>
                <span>{lineName}</span>
                <span>
                  {um} {quantity}&quot;
                </span>
              </div>
              Para el día {capitalize(day?.text)}, {day?.number} de {month} de {year}
            </div>
            <hr />
          </>
        )}
        {isPozoOrLocation && (
          <ProgramPointList
            disabledInputPP={checkRol(aprobador) && !isPozoOrLocation}
            disabledInputQuantity={false}
            displayButtons={isPozoOrLocation}
            displayFixedlabel={false}
            editCSA
            estadoEnum={estadoEnum}
            eventoSigla={eventoSigla}
            idParteDiario={dailyWorkReportId}
            isLocation
            line={{
              lineName,
              positionName,
              unidadMedida,
              estadoEnum,
              tienePuntosPrograma
            }}
            lineName={lineName}
            loading={loading}
            positionName={positionName}
            selectedDate={date}
            setFieldValue={setFieldValue}
            showAlert={showAlert}
            showTitle
            showWarningOperationalData
            tipoAsignacion={asignationType}
            values={values}
            viewCSA
            // quantityTotalReturn={quantityTotalReturn}
          />
        )}
        {isPozoOrLocation ? (
          <div className="first-row mb-3 mt-3 d-flex">
            <div className="ml-3">
              <p className="form-label">Requiere conformidad</p>
              <Switch
                checked={values?.requireAccordance}
                falseLabel="NO"
                name="requireAccordance"
                onChange={async () => {
                  setFieldValue('requireAccordance', !values?.requireAccordance);
                  setFieldTouched('requireAccordance');
                }}
                size="sm"
                trueLabel="SI"
              />
            </div>
            <div className="ml-3">
              <p className="form-label">Solicitar adjuntar evidencia</p>
              <Switch
                checked={values?.requestAttachFile}
                falseLabel="NO"
                name="requestAttachFile"
                onChange={async () => {
                  setFieldValue('requestAttachFile', !values?.requestAttachFile);
                  setFieldTouched('requestAttachFile');
                }}
                size="sm"
                trueLabel="SI"
              />
            </div>
            <div className="ml-3 w-100">
              <TextArea
                label="Comentario"
                maxLength={512}
                name="comment"
                onChange={async (e) => {
                  setFieldValue('comment', e.target.value);
                  setFieldTouched('comment');
                }}
                placeholder="Motivo de rechazo"
                resize={false}
                value={values?.comment}
              />
            </div>
          </div>
        ) : (
          <>
            <div className="first-row mb-3 d-flex">
              <div className="ml-3 align-items-center">
                <Input
                  className="d-block"
                  label="Proponer nueva cantidad"
                  name="quantity"
                  onChange={async (e) => {
                    const { value } = e.target;

                    if (validateDecimalInput(value, 3)) {
                      setFieldValue('quantity', e.target.value);
                      setFieldTouched('quantity');
                    }
                  }}
                  type="number"
                  value={values?.quantity}
                />
              </div>
              <div className="ml-3 align-items-center">
                <p className="form-label">Requiere conformidad</p>
                <Switch
                  checked={values?.requireAccordance}
                  falseLabel="NO"
                  name="requireAccordance"
                  onChange={async () => {
                    setFieldValue('requireAccordance', !values?.requireAccordance);
                    setFieldTouched('requireAccordance');
                  }}
                  size="sm"
                  trueLabel="SI"
                />
              </div>
              <div className="ml-3 align-items-center">
                <p className="form-label">Solicitar adjuntar evidencia</p>
                <Switch
                  checked={values?.requestAttachFile}
                  falseLabel="NO"
                  name="requestAttachFile"
                  onChange={async () => {
                    setFieldValue('requestAttachFile', !values?.requestAttachFile);
                    setFieldTouched('requestAttachFile');
                  }}
                  size="sm"
                  trueLabel="SI"
                />
              </div>
            </div>
            <div className="ml-3 comment-input-container">
              <TextArea
                label="Comentario"
                maxLength={512}
                name="comment"
                onChange={async (e) => {
                  setFieldValue('comment', e.target.value);
                  setFieldTouched('comment');
                }}
                placeholder="Motivo de rechazo"
                resize={false}
                value={values?.comment}
              />
            </div>
          </>
        )}
      </>
    </ModalGeneric>
  );
};

export default RejectModal;

RejectModal.propTypes = {
  show: PropTypes.bool,
  onHide: PropTypes.func,
  onAccept: PropTypes.func,
  dailyWorkReportId: PropTypes.number,
  positionName: PropTypes.string,
  lineName: PropTypes.string,
  um: PropTypes.string,
  quantity: PropTypes.number,
  date: PropTypes.string,
  asignationType: PropTypes.number,
  tienePuntosPrograma: PropTypes.bool,
  estadoEnum: PropTypes.number.isRequired,
  unidadMedida: PropTypes.string.isRequired,
  tipoUbicacionEnum: PropTypes.number.isRequired,
  eventoSigla: PropTypes.string.isRequired,
  line: PropTypes.shape({})
};

RejectModal.defaultProps = {
  show: false,
  onHide: () => {
    /* Empty */
  },
  onAccept: () => {
    /* Empty */
  },
  dailyWorkReportId: null,
  positionName: '',
  lineName: '',
  um: '',
  quantity: 0,
  date: '',
  asignationType: 0,
  tienePuntosPrograma: false,
  line: {}
};
